export default "../images/stackloans-partners-with-FreedomPlus_PORTAL_US.png?ea33784184616ffa181a300f89e9a68d";